import { isSpatiusProvider } from "@/hooks/spatius-primary-session-policy";
import type { AgentConnectionState } from "@/hooks/useLiveKitAgent";

type SessionUiStateArgs = {
  configuredAvatarProvider: string;
  connectionState: AgentConnectionState;
  hasSpatiusAvatarSession: boolean;
  isConnected: boolean;
  isRecording: boolean;
  selectedNoAvatar: boolean;
};

export function shouldBootstrapConnectingAvatar({
  configuredAvatarProvider,
  connectionState,
  isConnected,
  isRecording,
  selectedNoAvatar,
}: SessionUiStateArgs) {
  return (
    isRecording &&
    !selectedNoAvatar &&
    connectionState !== "failed" &&
    !isConnected &&
    !isSpatiusProvider(configuredAvatarProvider)
  );
}

export function shouldDisableSessionAvatar({
  configuredAvatarProvider,
  hasSpatiusAvatarSession,
  selectedNoAvatar,
}: Pick<
  SessionUiStateArgs,
  "configuredAvatarProvider" | "hasSpatiusAvatarSession" | "selectedNoAvatar"
>) {
  if (selectedNoAvatar) {
    return true;
  }

  return isSpatiusProvider(configuredAvatarProvider) && !hasSpatiusAvatarSession;
}

export function shouldRenderTranscriptionSession({
  isConnected,
  isRecording,
}: Pick<SessionUiStateArgs, "isConnected" | "isRecording">) {
  return isConnected && isRecording;
}
